export const insuranceChoices = [
    {
        "code": "111",
        "name": "111 - Všeobecná zdravotní pojišťovna"
    },
    {
        "code": "201",
        "name": "201 - Vojenská zdravotní pojišťovna"
    },
    {
        "code": "205",
        "name": "205 - Česká průmyslová zdravotní pojišťovna"
    },
    {
        "code": "207",
        "name": "207 - Oborová zdravotní pojišťovna"
    },
    {
        "code": "209",
        "name": "209 - Zaměstnanecká pojišťovna Škoda"
    },
    {
        "code": "211",
        "name": "211 - Zdravotní pojišťovna ministerstva vnitra"
    },
    {
        "code": "213",
        "name": "213 - Revírní bratrská pokladna"
    }
];
